import React, { Fragment, useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const Dropdown = props => {
    const selectRef = useRef(null);
    const {
        label: {
            ariaLabel,
            labelText,
            labelClasses,
            wrapperClasses,
            textReplacements
        },
        inputData: {
            inputClasses,
            name,
            options,
            value,
            isInputRequired,
            fieldArrayIndex = undefined,
            fieldArray = [],
            selected = undefined
        },
        actions: {
            handleFieldChange,
            handleFieldBlur
        }
    } = props;

    useEffect(() => {
        if (!props.focusOnMount || !selectRef.current) return;
        selectRef.current.focus();
    }, [selectRef.current]);

    const intlApi = useIntl();

    const selectText = intlApi.formatMessage({ id: 'ssap.input.option.select' });
    const keyPress = e => {
        const isEnterOrSpace = e.key === ' ' || e.key === 'SpaceBar' || e.key === 'Enter' || e.keyCode === 32 || e.keyCode === 13;
        if (isEnterOrSpace) {
            handleFieldChange(e);
        }
    };

    const handleValueChange = (e) => {
        handleFieldChange({ target: { name, value: e.target.value } }, fieldArray, fieldArrayIndex);
    };
    const handleValueBlur = (e) => {
        handleFieldBlur({ target: { name, value: e.target.value } }, fieldArray, fieldArrayIndex);
    };

    return (
        <Fragment>
            <div className={`gi-dropdown ${wrapperClasses && wrapperClasses.join(' ')}`}>
                <label
                    htmlFor={name}
                    className={`gi-label gi-input__label ${labelClasses && labelClasses.join(' ')} required-${isInputRequired}`}
                    aria-label={ariaLabel}
                >
                    <FormattedMessage id={ labelText } values={ { ...textReplacements }}/>
                </label>
                <select
                    ref={selectRef}
                    id={name}
                    data-automation-id={name}
                    className={inputClasses && inputClasses.join(' ')}
                    name={name}
                    value={value}
                    aria-required={isInputRequired}
                    onKeyPress={keyPress}
                    onChange={(e) => handleValueChange(e)}
                    onBlur={(e) => handleValueBlur(e)}
                >
                    {
                        options.map((option, idx) => (
                            <option
                                key={`${option.value}_${idx}`}
                                value={option.value}
                                defaultValue={ option.value === selected }
                                id={option.id ? option.id : `${option.value}_${idx}`}
                            >
                                {
                                    (value === undefined || value === null || value === '') && option.value === 'default' ?
                                        selectText :
                                        option.text
                                }
                            </option>
                        ))
                    }
                </select>
            </div>
        </Fragment>
    );
};

export default Dropdown;